import * as Yup from 'yup';
import { TypeOfUser } from '@pharmaplan/common';
import strings from '../../../localization';
import {
  nameRegex,
  onlyNumbersRegex,
  postalCodeRegExp,
} from '../../../helpers/Constants';
import { incorporatedProfessionalValidator } from '../../../helpers/commonValidators';

export const onlyNumbers = Yup.string().matches(
  onlyNumbersRegex,
  strings.formatString(
    strings.pleaseEnterValidFormat,
    strings.number.toLowerCase(),
  ) as string,
);

const pharmacistBasedValidation = () =>
  onlyNumbers.required(strings.requiredField).when('role', {
    is: (values: TypeOfUser) =>
      values !== TypeOfUser.pharmacist,
    then: () =>
      onlyNumbers.nullable(),
  });

const studentBasedValidation = () =>
  onlyNumbers.required(strings.requiredField).when('role', {
    is: (values: TypeOfUser) =>
      values === TypeOfUser.student,
    then: () =>
      onlyNumbers.nullable(),
  });

const technicianBasedValidation = () =>
  Yup.string()
    .nullable()
    .when('role', {
      is: (values: TypeOfUser) =>
        values === TypeOfUser.technician,
      then: () =>
        Yup.string().required(strings.requiredField),
    });

const professionalValidation = () =>
  ({
    licenseNumber: pharmacistBasedValidation(),
    pharmacistCapacityId: Yup.string().required(strings.requiredField),
    graduationYear: studentBasedValidation(),
    otherLanguages: Yup.string(),
    diploma: technicianBasedValidation(),
    instituteName: technicianBasedValidation(),
    techGraduationYear: technicianBasedValidation(),
  });

const selfProfessionalValidation = () =>
  ({
    licenseNumber: pharmacistBasedValidation(),
    graduationYear: studentBasedValidation(),
    pharmacistCapacityId: Yup.string().required(strings.requiredField),
    diploma: technicianBasedValidation(),
    instituteName: technicianBasedValidation(),
    techGraduationYear: technicianBasedValidation(),
  });

export const GeneralValidator = (requiresNames = true) =>
  Yup.object().shape({
    image: Yup.mixed().required(strings.requiredField),
    ...(requiresNames && {
      firstName: Yup.string()
        .required(strings.requiredField)
        .matches(nameRegex, strings.pleaseEnterValidName),
      lastName: Yup.string()
        .required(strings.requiredField)
        .matches(nameRegex, strings.pleaseEnterValidName),
    }),
    preferdLanguage: Yup.string().required(strings.requiredField),
    selectedContactPreferences: Yup.array().min(1, strings.pleaseSelectOne),
  });

export const ProfessionalValidator = () =>
  Yup.object().shape(professionalValidation());

export const SoftwareValidator = () =>
  Yup.object().shape({});
export const ContactValidator = (requiresWorkEthics = false) =>
  Yup.object().shape({
    province: Yup.string().required(strings.requiredField),
    address: Yup.string().required(strings.requiredField),
    city: Yup.string().required(strings.requiredField),
    postalCode: Yup.string()
      .required(strings.requiredField)
      .matches(postalCodeRegExp, strings.postalCodeValidation),
    phone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      ),
    mobile: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      ),
    ...(requiresWorkEthics && {
      workEthicsAccepted: Yup.bool().oneOf(
        [true],
        strings.workEthicsValidation,
      ),
    }),
  });

export const professionalCorporatedValidator = () =>
  Yup.object().shape({
    ...selfProfessionalValidation(),
    ...incorporatedProfessionalValidator(),
  });
